@if (loading()) {
  <div class="compare-state">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Loading form...</span>
  </div>
} @else if (failed()) {
  <div class="compare-state">
    <i class="pi pi-exclamation-triangle"></i>
    <span>This form could not be loaded.</span>
  </div>
} @else if (questions(); as questions) {
  @if (questions.length === 0) {
    <div class="compare-state">
      <span>This form has no questions.</span>
    </div>
  } @else {
    <app-question-list
      class="compare-question-list"
      [questions]="questions"
      [showQuestionNumbers]="showQuestionNumbers()"
      [isReadOnly]="true"
      [previewMode]="true" />
  }
}
